<template>
  <div class="h5-carts">
    <Header class="h5-carts__header" />
    <div class="h5-carts__wrapper">
      <div class="h5-carts__content">
        <ExpressCheckout />
        <div class="h5-carts__main">
          <CartsList />
          <div class="h5-carts__footer">
            <div class="h5-carts__card">
              <ShippingMethod class="h5-carts__shipping" />
              <p class="h5-carts__title">
                Order Summary
              </p>
              <OrderSummary class="h5-carts__summary" />
            </div>
            <img
              class="h5-carts__endorsement"
              src="@/assets/carts/endorsement.png"
              @click="showEndorsement = true"
            >
          </div>
        </div>
        <Checkout class="h5-carts__checkout" />
      </div>
    </div>
    <H5PageDialog
      v-model:show="showAddressDialog"
      title="Shipping Address"
    >
      <H5AddressInfo
        :handle-close="() => showAddressDialog = false"
        :address-type="3"
        :current-country="ship.country"
      />
    </H5PageDialog>
    <Popup
      v-model:show="showEndorsement"
      teleport="body"
      position="bottom"
    >
      <BuyerGuarantee
        @close="showEndorsement = false"
      />
    </Popup>
  </div>
</template>

<script setup>
import { watchOnce } from '@vueuse/core'
import Header from './components/Header.vue'
import ExpressCheckout from './components/ExpressCheckout.vue'
import CartsList from './components/CartsList.vue'
import ShippingMethod from './components/ShippingMethod.vue'
import OrderSummary from '../components/OrderSummary.vue'
import Checkout from './components/Checkout.vue'
import H5AddressInfo from '@/components/H5/H5AddressInfo/index.vue'
import { H5PageDialog } from '@/components/H5PageDialog'
import { useAddress } from './hooks/useAddress'
import { buriedPointUtil, gaAnalytics } from '@/utils/utils'
import { useAddressStore } from '@/pinia/address'
import { Popup } from '@/components/Popup'
import BuyerGuarantee from '@/views/OfferView/components/OfferViewH5/components/BuyerGuarantee.vue'
import { useShipStore } from '@/pinia/ship'
import { useCart } from '../hooks/useCart'

const addressStore = useAddressStore()
const { showAddressDialog } = useAddress()
const { cartList } = useCart()

const ship = useShipStore()

const showEndorsement = ref(false)

onMounted(() => {
  gaAnalytics('mp_cart_page_view', 'mp_cart_page_view')
  buriedPointUtil({ eventId: 'MPC501' })
})

onMounted(() => {
  /**
   * 用户无收货地址打开购物车自动弹出填写地址弹窗
   */
  if (!addressStore.cacheAddress) {
    showAddressDialog.value = true
  }
})

watchOnce(cartList, (list) => {
  if (list.length) {
    buriedPointUtil({ eventId: 'HCL401' })
  }
})
</script>

<style lang="less" scoped>
.h5-carts {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #000000;
  color: #232323;

  &__header {
    flex-shrink: 0;
    margin: 12px;
  }

  &__wrapper {
    flex: 1;
    margin: 0 12px 12px;
    border-radius: 8px;
    overflow: hidden;
  }

  &__content {
    height: 100%;
    overflow-y: auto;
  }

  &__main {
    border-radius: 8px;
    background-color: #FFFFFF;
  }

  &__footer {
    padding: 24px 12px 16px;
  }

  &__card {
    padding: 20px 16px;
    background-color: #F8F8F8;
    border-radius: 8px;
  }

  &__title {
    margin-top: 16px;
    font-family: mon-700;
    font-size: 16px;
    line-height: 24px;
  }

  &__summary {
    margin-top: 12px;
  }

  &__endorsement {
    margin-top: 16px;
    width: 100%;
    aspect-ratio: 2.7380952381;
  }

  &__checkout {
    margin-top: 16px;
  }
}
</style>
